module.exports = __webpack_public_path__ + "img/gift.5588d2ca.gif";